module.exports = __webpack_public_path__ + "img/m_home_news.fd4f3877.png";